import Privileges from './Privileges';

export default Privileges;
